const guiColors = {
    'motion-primary': 'hsla(178, 65%, 45%, 1)',
    'motion-primary-transparent': 'hsla(178, 65%, 45%, 0.9)',
    'motion-tertiary': 'hsla(178, 49%, 44%, 1)',

    'looks-secondary': 'hsla(178, 65%, 45%, 1)',
    'looks-transparent': 'hsla(178, 65%, 45%, 0.35)',
    'looks-light-transparent': 'hsla(178, 65%, 45%, 0.15)',
    'looks-secondary-dark': 'hsla(178, 49%, 44%, 1)',

    'extensions-primary': 'hsla(188, 55%, 45%, 1)',
    'extensions-tertiary': 'hsla(188, 55%, 20%, 1)',
    'extensions-transparent': 'hsla(188, 55%, 45%, 0.35)',
    'extensions-light': 'hsla(188, 37%, 65%, 1)',

    'drop-highlight': 'hsl(178, 65%, 58%)'
};

const blockColors = {
    checkboxActiveBackground: 'hsl(178, 65%, 45%)',
    checkboxActiveBorder: 'hsl(178, 49%, 44%)'
};

export {
    guiColors,
    blockColors
};